import React from 'react';
import { useAuth } from '../context/AuthContext';
import { SkeletonCard } from './LoadingSkeleton';
import AdminAccessPage from '../pages/AdminAccessPage';

export default function AdminProtectedRoute({ children }) {
  const { user, backendUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="admin-loading-screen" style={{ padding: '60px 20px', maxWidth: '1200px', margin: '0 auto' }}>
        <SkeletonCard />
      </div>
    );
  }

  if (!user || backendUser?.role !== 'admin') {
    return <AdminAccessPage signedIn={Boolean(user)} />;
  }

  return children;
}
